import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { ArrowLeftIcon, ZoomInIcon, XIcon } from 'lucide-react';
import { useBackNavigation } from '../hooks/useBackNavigation';
export function Expressive() {
  const [selectedImage, setSelectedImage] = useState<string | null>(null);
  const goBack = useBackNavigation('/art');
  const artworks = [{
    image: 'https://storage.yandexcloud.net/maria-images/images/art/photo_2025-11-18_21-49-18.jpg',
    year: '2025',
    materials: 'Paper, pencil, pastel, oil, acrylic',
    description: 'Phōsphoros - Morning Star'
  }, {
    image: 'https://storage.yandexcloud.net/maria-images/images/art/IMG_20231201_172202_428%20(3).png',
    year: '2023',
    materials: 'Paper, pencil, marker',
    description: 'Shaman Calling'
  }, {
    image: 'https://storage.yandexcloud.net/maria-images/images/art/IMG_20240408_123848_351%20(1).jpg',
    year: '2024',
    materials: 'Paper, marker',
    description: 'Aries New Moon'
  }, {
    image: 'https://storage.yandexcloud.net/maria-images/images/art/20231010_002657%20(1).jpg',
    year: '2023',
    materials: 'Paper, acrylic',
    description: 'Tantra'
  }, {
    image: 'https://storage.yandexcloud.net/maria-images/images/art/Screenshot_20240901_001757_Gallery%20(1).jpg',
    year: '2024',
    materials: 'Paper, pencil, watercolour',
    description: 'Union'
  }, {
    image: 'https://storage.yandexcloud.net/maria-images/images/art/20240125_041734%20(1).jpg',
    year: '2023',
    materials: 'Paper, marker',
    description: 'NeoMother'
  }, {
    image: 'https://storage.yandexcloud.net/maria-images/images/art/20231010_003036.jpg',
    year: '2022',
    materials: 'Card, pastel',
    description: 'Unraveling'
  }, {
    image: 'https://storage.yandexcloud.net/maria-images/images/art/photo_2025-11-18_21-49-23.jpg',
    year: '2025',
    materials: 'Paper, oil',
    description: 'Wheel of Fortune'
  }, {
    image: 'https://storage.yandexcloud.net/maria-images/images/art/20231004_013502.jpg',
    year: '2017',
    materials: 'Paper, linocut',
    description: 'Summit'
  }, {
    image: 'https://storage.yandexcloud.net/maria-images/images/art/20231004_020355%20(1).jpg',
    year: '2017',
    materials: 'Paper, crayon',
    description: 'Gut Sense'
  }];
  return <div className="w-full min-h-screen bg-white" data-id="element-1486">
      {/* Image Modal */}
      {selectedImage && <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} exit={{
      opacity: 0
    }} className="fixed inset-0 z-50 flex items-center justify-center bg-black/90 p-4" onClick={() => setSelectedImage(null)} data-id="element-1487">
          <button onClick={() => setSelectedImage(null)} className="absolute top-4 right-4 text-white hover:text-cyan-400 transition-colors" data-id="element-1488">
            <XIcon className="w-8 h-8" data-id="element-1489" />
          </button>
          <motion.img initial={{
        scale: 0.9
      }} animate={{
        scale: 1
      }} src={selectedImage} alt="Enlarged view" className="max-w-full max-h-full object-contain" data-id="element-1490" />
        </motion.div>}
      {/* Header */}
      <header className="py-4 px-6 bg-white border-b border-stone-200 sticky top-0 z-40" data-id="element-1491">
        <div className="max-w-7xl mx-auto flex items-center justify-between" data-id="element-1492">
          <button onClick={goBack} className="inline-flex items-center gap-2 text-stone-600 hover:text-stone-900 transition-colors" data-id="element-1493">
            <ArrowLeftIcon className="w-5 h-5" data-id="element-1494" />
            <span className="font-light" data-id="element-1495">Back</span>
          </button>
          <h1 className="text-2xl font-light text-stone-900" data-id="element-1496">Maria Elina</h1>
        </div>
      </header>
      {/* Hero Section */}
      <section className="py-10 px-6 bg-gradient-to-br from-stone-50 via-cyan-50/30 to-stone-50" data-id="element-1497">
        <div className="max-w-5xl mx-auto" data-id="element-1498">
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8
        }} data-id="element-1499">
            <p className="text-cyan-600 font-light tracking-wide uppercase mb-2" data-id="element-1500">
              Abstract & Emotional
            </p>
            <h1 className="text-4xl md:text-6xl font-light text-stone-900 mb-4" data-id="element-1501">
              Expressive
            </h1>
            <p className="text-xl text-stone-600 font-light" data-id="element-1502">
              Bold, intuitive works exploring color, texture, and emotion
              through forms, materials, gestural mark-making and pattern
            </p>
          </motion.div>
        </div>
      </section>
      {/* Gallery Grid */}
      <section className="py-20 px-6 bg-white pt-[40px]" data-id="element-1503">
        <div className="max-w-7xl mx-auto" data-id="element-1504">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-1505">
            {artworks.map((artwork, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 30
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.6,
            delay: index * 0.1
          }} className="group" data-id="element-1506">
                <div className="relative overflow-hidden rounded-xl shadow-lg mb-4 aspect-square cursor-pointer" onClick={() => setSelectedImage(artwork.image)} data-id="element-1507">
                  <img src={artwork.image} alt={`Artwork ${index + 1}`} className="w-full h-full object-cover" data-id="element-1508" />
                  <div className="absolute inset-0 bg-stone-900/0 group-hover:bg-stone-900/10 transition-colors duration-300 flex items-center justify-center" data-id="element-1509">
                    <ZoomInIcon className="w-8 h-8 text-white opacity-0 group-hover:opacity-100 transition-opacity duration-300" data-id="element-1510" />
                  </div>
                </div>
                <div className="space-y-2" data-id="element-1511">
                  <p className="text-sm text-cyan-600 font-light" data-id="element-1512">
                    {artwork.year} • {artwork.materials}
                  </p>
                  <p className="text-stone-600 font-light text-sm leading-relaxed" data-id="element-1513">
                    {artwork.description}
                  </p>
                </div>
              </motion.div>)}
          </div>
        </div>
      </section>
    </div>;
}